import { SimpleProductInfo } from '@/types/products/simple-product-info';
import { WithQuantity } from '@/types/products/with-quantity';

export const getShoppingCartProductsNum = (
  products: WithQuantity<SimpleProductInfo>[] | undefined,
) => products?.reduce((prev, curr) => prev + curr.quantity, 0) || 0;
